import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import AccountTag from '../lib/AccountTag';
import EmptyStateNoRecord from '../lib/EmptyStateNoRecord';
import Loading from '../common/Loading';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import AdvancedTable from '../lib/AdvancedTable';
import { FormattedNumber } from 'react-intl';

const MPTokenHolder = (props) => {
    const { mpt } = props;
    const [ mptHolders, setMptHolders ] = useState([]);
    const [ loading, setLoading ] = useState(false);

    const columns = useMemo(
        () => [
            {
                Header: `Top holders`,
                columns: [
                {
                    Header: "#",
                    accessor: "index",
                },
                {
                    Header: "Account",
                    accessor: "account",
                    Cell: ({ cell: { value }}) => <span className='text-monospace'><AccountTag link>{value}</AccountTag></span>,
                },
                {
                    Header: "Amount",
                    accessor: "mpt_amount",
                    className: "text-right",
                    Cell: ({ cell: { value }}) => <span className='text-monospace'><FormattedNumber value={value / 10**mpt.AssetScale} maximumFractionDigits={20}/></span>,
                },
                {
                    Header: "Holding",
                    accessor: "holdingPercent",
                    className: "text-right",
                    Cell: ({ cell: { value }}) => <span className='text-monospace'><FormattedNumber value={value} maximumFractionDigits={8} />%</span>,
                },
                {
                    Header: "Object",
                    accessor: "mptoken_index",
                    className: "text-right",
                    Cell: ({ cell: { value }}) => <span className="address-tag address-tag-lga"><Link to={`/object/${value}`}>{value}</Link></span>,
                },
                ],
            },
            ],
            [mpt],
    )

    /*
    * Add custom properties to represent Money etc.
    */
    const addProperties = useCallback((holders) => {
        const populatedProperties = holders.map((holder, index) => {
            holder.index = index + 1
            holder.holdingPercent = (holder.mpt_amount / mpt.MaximumAmount) * 100;
            return holder;
        });
        return populatedProperties;
    }, [mpt]);

    useEffect(() => {
        if (typeof mpt?.mpt_issuance_id === 'string') {
            setLoading(true);
            fetch(`${XRPSCAN_API_URL}/mpt/${mpt?.mpt_issuance_id}/holders`)
            .then(handleResponse)
            .then((data) => {
                setMptHolders(addProperties(data.mptokens));
            })
            .catch((error) => {
                setMptHolders([]);
            })
            .finally(() => {
                setLoading(false);
            });
            return () => {
                setMptHolders([]);
            }
        }
    }, [mpt, addProperties]);

    if (loading) {
        return <Loading/>;
    }

    if (!loading && mptHolders?.length === 0) {
        return (
            <EmptyStateNoRecord title="No MPToken holders">
                This MPToken is not held by any account.
            </EmptyStateNoRecord>
        )
    } else {
        return <AdvancedTable
            columns={columns}
            data={mptHolders}
            filterProperty='account'
            filterPlaceholder='Search MPToken holder'
            initialPageSize={500}
        />
    }
}

MPTokenHolder.propTypes = {
    mpt: PropTypes.object.isRequired,
}

export default MPTokenHolder;